const getDefaultState = () => {
    return {
        loading: 0,
        search: null,
        handlingChargesEntries: [
            { text: "15 mins", value: 15 },
            { text: "30 mins", value: 30 },
            { text: "45 mins", value: 45 },
            { text: "60 mins", value: 60 },
            { text: "75 mins", value: 75 },
            { text: "90 mins", value: 90 },
            { text: "105 mins", value: 105 },
            { text: "120 mins", value: 120 },
        ],
        alert: {
            show: false,
            color: "",
            text: "",
            icon: "",
            timeout: "",
        },
        popup: {
            id: null,
            type: null,
            show: false,
        },
        footerProps: {
            "items-per-page-all-text": "All",
            "items-per-page-options": [5, 15, 25, 35, -1],
            "show-current-page": true,
        },
    };
};

export default {
    state: () => getDefaultState(),
    getters: {
        getLoading: state => state.loading > 0,
        getSearch: state => state.search,
        getHandlingChargesEntries: state => state.handlingChargesEntries,
        getFooterProps: state => state.footerProps,
    },
    mutations: {
        setLoading: (state, bool) => {
            if (bool) {
                state.loading++;
            } else {
                state.loading--;
            }
        },
        setSearch: (state, search) => {
            state.search = search;
        },
        alert: (state, status) => {
            clearTimeout(state.alert.timeout);
            state.alert.text = status.text;
            state.alert.color = status.color;
            state.alert.icon = status.icon;
            state.alert.show = true;
            state.alert.timeout = setTimeout(() => {
                state.alert.show = false;
            }, 5000);
        },
        popUp: (state, payload) => {
            state.popup.type = payload.type;
            state.popup.id = payload.id;
            state.popup.show = true;
        },
    },
    actions: {
        generalErrorHandling: ({ dispatch, commit }, e) => {
            let textResponse = "";
            if (e.response) {
                if (e.response.status === 401) {
                    textResponse =
                        "Your session has expired. Please log in again.";
                    dispatch("logout");
                } else if (e.response.status === 500) {
                    textResponse = "Server error";
                } else if (e.response.status === 400) {
                    textResponse =
                        "An error occurred. Please make sure you filled in all entries correctly and try again.";
                } else if (e.response.message) {
                    const { message } = e.response;
                    textResponse = message;
                } else if (e.response.data && e.response.data.message) {
                    const { message } = e.response.data;
                    textResponse = message;
                } else {
                    textResponse = "An error occurred. Please try again.";
                }
            } else {
                textResponse = "Network error. Please try again.";
            }
            commit({
                type: "alert",
                text: textResponse,
                color: "error",
                icon: "warning",
            });
        },
    },
};
